module.exports = __webpack_public_path__ + "img/mdacc_logo.48e476ca.png";